import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetSelectionCompanies } from './companyThunk';
import { ICompany } from '~/utils/interface/company';

export interface CompanyState {
  companies: Array<ICompany>;
  needRefreshData: boolean;
}

const initialState: CompanyState = {
  companies: [],
  needRefreshData: false,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetSelectionCompanies.pending, (_state, _action) => {})

      .addCase(handleGetSelectionCompanies.fulfilled, (state, action) => {
        state.companies = [...action.payload.responses];

        state.needRefreshData = false;
      })

      .addCase(handleGetSelectionCompanies.rejected, (_state, _action) => {});
  },
});

export const companyActions = companySlice.actions;

const companyReducer = companySlice.reducer;
export default companyReducer;
